export default {
    it: {
        "name": "Nome*:",
        "surname": "Cognome*:",
        "telephone": "Recapito telefonico*:",
        "email": "Indirizzo e-mail*:",
        "notes": "Note integrative:",
        "form-field-ok": "Ok!",
        "name-field-not-ok": "Per favore inserisci il nome",
        "surname-field-not-ok": "Per favore inserisci il cognome",
        "email-field-not-ok": "Per favore inserisci un indirizzo email valido",
        "telephone-field-not-ok": "Per favore un recapito telefonico valido",
        "submit-request": "Invia richiesta",
        "terms-and-conditions": "",
        "terms-and-conditions-not-ok": "Devi accettare prima di procedere",
        "privacy": "Consenso per la ",
        "remaining-characters": "Ti rimangono: ",
        "characters": " caratteri",
        "required-fields": "*Campi obbligatori",
        "required-fields-telephone": "**Devi fornire almeno un numero di telefono",
        "required-fields-pivacodfis": "**Devi fornire almeno uno tra il tuo codice fiscale e la tua p.iva",
        "required-fields-nsr": "**Devi fornire almeno uno tra nome/cognome e ragione sociale"

    },
    en: {
        "name": "Name*:",
        "surname": "Cognome*:",
        "telephone": "Phone number*:",
        "email": "Email*:",
        "notes": "Notes:",
        "form-field-ok": "Ok!",
        "name-field-not-ok": "Please choose a name",
        "surname-field-not-ok": "Please choose a surname",
        "email-field-not-ok": "Please a valid email",
        "telephone-field-not-ok": "Please choose a valid phone number",
        "submit-request": "Submit request",
        "terms-and-conditions": "I authorize the processing of my personal data pursuant to Legislative Decree 196/2003 and to the article 13 GDPR 679/16.",
        "terms-and-conditions-not-ok": "You must agree before submitting",
        "privacy": "Consent for ",
        "remaining-characters": "You have ",
        "characters": " characters",
        "required-fields": "*Required fields",
        "required-fields-telephone": "**You must provide at least one phone number",
        "required-fields-pivacodfis": "**Devi fornire almeno uno tra il tuo codice fiscale e la tua p.iva",
        "required-fields-nsr": "**Devi fornire almeno uno tra nome/cognome e ragione sociale"
    }
}